<template>
	<div class="timelineResourcesHeader">
		<Checkbox
			v-model="isSelected"
			:indeterminate="isIndeterminate"
			:value="true"
			label="Products"
			:disabled="isReadonly || isUpdateEvent"
			@update:model-value="emit('toggle')"
		>
			<template #label-text>
				<div class="flex items-baseline">
					<span class="font-body-s mr-03"> Products </span>
					<span class="font-caption text-ink-87"> {{ totalCount }} total </span
					><span v-if="selectedCount > 0" class="font-caption text-ink-87">&nbsp;· {{ selectedCount }} selected </span>
				</div>
			</template>
		</Checkbox>
	</div>
</template>

<script setup lang="ts">
import { Checkbox } from '@bluebrick/saas-ui'
import { storeToRefs } from 'pinia'
import { watch, computed, toRefs, ref } from 'vue'
import { useEventDetailsStore } from '@/features/eventDetails/useEventDetailsStore'

const props = defineProps<{
	totalCount: number
	selectedCount: number
}>()

const { totalCount, selectedCount } = toRefs(props)

const emit = defineEmits(['toggle'])

const { isReadonly, isUpdateEvent } = storeToRefs(useEventDetailsStore())

const isSelected = ref(false)

const isIndeterminate = computed(() => totalCount.value > 0 && selectedCount.value > 0 && selectedCount.value < totalCount.value)

watch(
	[totalCount, selectedCount],
	() => {
		isSelected.value = totalCount.value > 0 && selectedCount.value === totalCount.value
	},
	{ immediate: true }
)
</script>
